import React from "react"
import EmptyState from "../Questions/components/EmptyState"
import useLearnerAuth from "../../../auth/learner/useLearnerAuth"
import DashboardActivityPanel from "./components/DashboardActivityPanel"
import DashboardGoalsPanel from "./components/DashboardGoalsPanel"
import DashboardHeader from "./components/DashboardHeader"
import DashboardQuickLinks from "./components/DashboardQuickLinks"
import DashboardStatsGrid from "./components/DashboardStatsGrid"
import useDashboardData from "./hooks/useDashboardData"
import "./DashboardPage.style.scss"

const DashboardPage = () => {
  const { student } = useLearnerAuth()
  const {
    stats,
    statsLoading,
    statsError,
    activities,
    activitiesLoading,
    activitiesError,
    goals,
    goalsLoading,
    goalsError,
    isSavingGoal,
    quickLinks,
    addGoal,
  } = useDashboardData()
  const firstName = student?.first_name?.trim() || "Learner"

  return (
    <div className="dashboard-page">
      <div className="dashboard-page__inner">
        <DashboardHeader firstName={firstName} />
        {statsLoading ? (
          <EmptyState title="Loading dashboard stats…" />
        ) : statsError ? (
          <EmptyState
            title="Couldn’t load dashboard stats"
            description={statsError}
          />
        ) : (
          <DashboardStatsGrid stats={stats} />
        )}
        <div className="dashboard-page__columns">
          <DashboardGoalsPanel
            goals={goals}
            loading={goalsLoading}
            error={goalsError}
            isSaving={isSavingGoal}
            onAddGoal={addGoal}
          />
          <DashboardActivityPanel
            activities={activities}
            loading={activitiesLoading}
            error={activitiesError}
          />
        </div>
        <DashboardQuickLinks links={quickLinks} />
      </div>
    </div>
  )
}

export default DashboardPage
